export default {
	notification_health: 'Стан сповіщень',
	notification_health_summary: 'Підсумок',
	notification_health_loading: 'Перевірка стану сповіщень...',
	notification_health_refresh: 'Оновити',
	notification_health_fix: 'Що робити',
	notification_health_unavailable: 'Не вдалося завантажити стан сповіщень',
	notification_health_healthy: 'Справний',
	notification_health_blocked: 'Заблоковано',
	notification_health_degraded: 'Потребує уваги',
	notification_health_no_app_user: 'Немає входу в додаток',
	notification_health_unknown: 'Невідомо',
	notification_health_app_version: 'Версія додатка',
	notification_health_last_delivery: 'Остання доставка',
	notification_health_time_just_now: 'щойно',
	notification_health_time_minutes: '{count} хв тому',
	notification_health_time_hours: '{count} год тому',
	notification_health_time_days: '{count} дн тому',
	notification_health_time_unknown: 'невідомо',
	notification_health_summary_healthy: 'Сповіщення мають працювати',
	notification_health_summary_no_app_user: 'Прибиральник не входив у мобільний додаток',
	notification_health_summary_blocked_no_token: 'Push-токен відсутній — прибиральник має відкрити додаток і увійти',
	notification_health_summary_blocked_off: 'Сповіщення вимкнено в додатку',
	notification_health_check_portal_contact_label: 'Контакт у порталі існує',
	notification_health_check_portal_active_label: 'Контакт активний',
	notification_health_check_portal_rooms_label: 'Кімнати призначено',
	notification_health_check_portal_shifts_label: 'Зміни призначено',
	notification_health_check_app_user_label: 'Увійшов у мобільний додаток',
	notification_health_check_push_token_label: 'Push-токен зареєстровано',
	notification_health_check_notification_mode_label: 'Режим сповіщень',
	notification_health_check_time_schedule_label: 'У межах вікна сповіщень',
	notification_health_check_ios_geo_filter_label: 'Фільтр місцезнаходження iOS',
	notification_health_check_recent_push_attempt_label: 'Недавня спроба push (48 год)',
	notification_health_check_last_push_ignored_label: 'Останній сигнал не надіслано',
	notification_health_check_recent_push_delivered_label: 'Недавня доставка push (48 год)',
	notification_health_detail_portal_contact_found: 'Знайдено в порталі',
	notification_health_detail_portal_contact_missing: 'Запис контакту не знайдено',
	notification_health_detail_portal_active_active: 'Активний',
	notification_health_detail_portal_active_inactive: 'Неактивний',
	notification_health_detail_portal_rooms_assigned: '{count} кімн.',
	notification_health_detail_portal_rooms_none: 'Кімнати не призначено',
	notification_health_detail_portal_shifts_assigned: '{count} змін(и)',
	notification_health_detail_portal_shifts_none: 'Зміни не призначено',
	notification_health_detail_app_user_logged_in: 'Версія додатка {version}, остання синхронізація {lastSync}',
	notification_health_detail_app_user_never: 'Ніколи не входив',
	notification_health_detail_push_token_present: 'FCM-токен присутній',
	notification_health_detail_push_token_empty: 'Токен порожній',
	notification_health_detail_notification_mode: '{mode}',
	notification_health_detail_time_schedule_inside: 'Поточний час у межах розкладу',
	notification_health_detail_time_schedule_outside: 'Поточний час поза налаштованим розкладом',
	notification_health_detail_ios_geo_filter: '{filter}',
	notification_health_detail_recent_push_attempt_at: '{time}',
	notification_health_detail_recent_push_attempt_none: 'Немає спроб push за останні 48 годин',
	notification_health_detail_last_push_ignored: 'Останній запит push проігноровано (servik не налаштовано для робочої зони)',
	notification_health_detail_recent_push_delivered_at: '{time}',
	notification_health_detail_recent_push_delivered_none: 'Немає успішних доставок за останні 48 годин',
	notification_health_fix_portal_contact: 'Створіть цього прибиральника в панелі Користувачі',
	notification_health_fix_portal_active: 'Увімкніть перемикач Активний для цього прибиральника',
	notification_health_fix_portal_rooms: 'Призначте принаймні одну кімнату цьому прибиральнику',
	notification_health_fix_portal_shifts: 'Призначте принаймні одну зміну',
	notification_health_fix_app_user: 'Прибиральник має встановити додаток і увійти з цим номером телефону',
	notification_health_fix_push_token: 'Попросіть прибиральника відкрити додаток, дозволити сповіщення в налаштуваннях iOS і увійти знову',
	notification_health_fix_notification_mode: 'Змініть режим сповіщень з Вимк. на Завжди в додатку',
	notification_health_fix_time_schedule: 'Зачекайте до запланованого вікна або змініть режим на Завжди',
	notification_health_fix_ios_geo_filter: 'Прибиральник поза зоною сповіщень — попросіть відкрити додаток на об’єкті',
	notification_health_fix_last_push_ignored: 'Перевірте конфігурацію servik робочої зони для кімнати, що викликала сигнал',
	notification_health_fix_recent_push_delivered_filters: 'Перевірте фільтри сповіщень або налаштування пристрою',
	notification_health_fix_recent_push_delivered_token: 'Спочатку зареєструйте push-токен',
	notification_health_mode_on: 'Завжди',
	notification_health_mode_off: 'Вимк.',
	notification_health_mode_time: 'За розкладом',
	notification_health_mode_location: 'За місцезнаходженням',
	notification_health_filter_on: 'Увімк.',
	notification_health_filter_off: 'Вимк.',
};
